module.exports = __webpack_public_path__ + "img/icon-print-layout-vertical.8c59f9d0.svg";